import { render, staticRenderFns } from "./OnHoldRules.vue?vue&type=template&id=3e2dd62c&"
import script from "./OnHoldRules.vue?vue&type=script&lang=js&"
export * from "./OnHoldRules.vue?vue&type=script&lang=js&"
import style0 from "./OnHoldRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnHoldRules.vue"
export default component.exports